import {eposAxios} from "@/interceptors/axios";

class ProductionStatusService {
    _sequence = []


    get loaded() {
        return this._getProductionStatusData();
    }

    getAliases() {
        let aliases = {}
        //console.log(this._sequence);
        this._sequence.map(step => {
            let propName = step.name
                .toLocaleLowerCase()
                // this will camelcase the status name, by replacing all spaces with a following uppercase character
                .replace(/\ [a-z]/g, x => x[1].toUpperCase())
            aliases[propName] = step.id
        })

        return aliases
    }

    getNameForId(id) {
        let name = "Unknown status"
        this._sequence.map(status => {
            if (status.id == id) name = status.name
        })

        return name
    }

    before(target, value) {
        return this._compareValues(target, value, "lt")
    }

    beforeOrEqualTo(target, value) {
        return this._compareValues(target, value, "lte")
    }

    after(target, value) {
        return this._compareValues(target, value, "gt")
    }

    afterOrEqualTo(target, value) {
        return this._compareValues(target, value, "gte")
    }
    equalTo(target, value) {
        return this._compareValues(target, value, "eq")
    }

    _getProductionStatusData() {
        return eposAxios.get('/index.php?page=ajax&function=getProductionStatusData').then(response => {
           console.log(response.data.data);
            this._sequence = response.data.data.sequence;
        }).catch(error => {
            console.error('An error occurred logging the ProductionStatusData', error);
        });
    }

    _getSequenceIndexForId(id) {
        let result = null
        this._sequence.map((status, index) => {
            if (status.id == id) result = index
        })
        return result
    }

    _compareValues(target, value, comparison) {
        let targetSequenceIndex = this._getSequenceIndexForId(target)
        let valueSequenceIndex = this._getSequenceIndexForId(value)

        if (targetSequenceIndex === null || valueSequenceIndex === null) {
            console.error(
                "Invalid sequence indexes for comparison",
                targetSequenceIndex,
                valueSequenceIndex
            )
            return null
        }

        switch (comparison) {
            case "lt":
                return valueSequenceIndex < targetSequenceIndex
            case "lte":
                return valueSequenceIndex <= targetSequenceIndex
            case "gt":
                return valueSequenceIndex > targetSequenceIndex
            case "gte":
                return valueSequenceIndex >= targetSequenceIndex
            case "eq":
                return valueSequenceIndex == targetSequenceIndex
            default:
                console.error("Invalid comparison type", comparison)
                return null
        }
    }
}

export default new ProductionStatusService();